import React, { useState } from "react";
import { T } from '../traks';

export const InfoToolTip = ({ title, tooltipText, link }) => {
  const [isVisible, setIsVisible] = useState(false);

  const showTooltip = () => setIsVisible(true);
  const hideTooltip = () => setIsVisible(false);

  return (
    <span
      className="ad_info_tooltip"
      onMouseEnter={showTooltip}
      onMouseLeave={hideTooltip}
    >
      <span className="ad_info_icon">?</span>
      <span>
        {isVisible && (
          <div className="ad_tooltip_box">
            <strong className="ad_tooltip_title">{title}</strong>
            <p className="ad_tooltip_text">{tooltipText}</p>
            {link && (
              <strong className="ad_tooltip_link">
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <T>Click here for more info</T>
                </a>
              </strong>
            )}
          </div>
        )}
      </span>
    </span>
  );
};


// WEBPACK FOOTER //
// ./src/c/InfoToolTip.js